import '../../vendor/tocca.min';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';

window.Reverb = window.Reverb || {};

Reverb.MobileImageZoom = (function () {
  const thumb_selector = '.fotorama__active.fotorama__loaded--img img';
  let photoswipe_active = false;
  let active_thumbnail;


  let photoswipe_element;

  function init() {
    if (Reverb.MobileDetection.isMobileBrowser()) {
      bindToThumbnail();
    }
  }

  function bindToThumbnail() {
    $(document).on('tap', thumb_selector, function (e) {
      // Check if the tapped fotorama image is in a photoswipe-enabled fotorama gallery and that gallery is not open
      if ($(this).closest('.fotorama[data-photoswipe=true]').length > 0 && !photoswipe_active) {
        active_thumbnail = $(this);
        photoswipe_active = true;
        active_thumbnail.parent().spin();
        const fotorama_element = active_thumbnail.closest('.fotorama');
        const fotorama_data = fotorama_element.data('fotorama');
        if (fotorama_element.data('gallery-id')) {
          const gallery_id = active_thumbnail.closest('.fotorama').data('gallery-id');
          photoswipe_element = $(`.pswp#${gallery_id}`)[0];
        } else {
          photoswipe_element = $('.pswp')[0];
        }
        naturalDimensions(fotorama_data.activeFrame.full, function () {
          const pswp_items = [{ src: fotorama_data.activeFrame.full, w: this.width, h: this.height }];
          initGallery(photoswipe_element, pswp_items, active_thumbnail);
        });
      }
    });
  }

  function initGallery(photoswipe_element, pswp_items) {
    const gallery = new PhotoSwipe(photoswipe_element, PhotoSwipeUIDefault, pswp_items, { getThumbBoundsFn: getThumbBounds, tapToToggleControls: false });
    gallery.init();
    gallery.listen('destroy', () => {
      photoswipe_active = false;
    });
    gallery.listen('imageLoadComplete', (index, item) => {
      active_thumbnail.parent().stopSpinner();
    });
  }

  function naturalDimensions(img_src, callback) {
    const temp_img = new Image();
    temp_img.onload = callback;
    temp_img.src = img_src;
  }

  function getThumbBounds() {
    const thumbnail = active_thumbnail[0];
    const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    const rect = thumbnail.getBoundingClientRect();
    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
  }

  return {
    init,
  };
}());

$(Reverb.MobileImageZoom.init);
